import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom"
import useLoading from "../../../../hooks/useLoading";
import { useErrorSuccess } from "../../../../hooks/useErrorSuccess";
import api from "../../../../utils/api";
import { useServicesMensagens } from "../context/getMembros";

export type TMensagem = {
  id: number | undefined,
  ministerioGrupo: number | undefined
  tipo: 'Agendamento',
  frequencia: string,
  link: string
  mensagem: string
}

export const useServicesEditMensagem = () => {

  const { startLoading, isLoading, stopLoading } = useLoading();
  const { setMensagemError, setMensagemInfo } = useErrorSuccess();

  const { reset } = useServicesMensagens()

  const { id } = useParams();

  const [sede, setSede]  = useState<{sede: number}>();

  const [mensagem, setMensagem] = useState<TMensagem>();

  const alterMensagem = (field: keyof (TMensagem & {sede: number}), value: any) => {
    if(field == 'sede') {
      setSede({sede: value});
      return;
    }

    setMensagem((date) => ({...date, [field]: value }))
  }

  const getMensagem = async () => {
    startLoading();
    try {
      const req = await api.get('agendamento/bot/'+id);
      const res = await req.data;
      setMensagem(res);
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2))
    } finally {
      stopLoading();
    }
  }

  const { } = useQuery({
    queryKey: ['agendamento-bot-get', id],
    queryFn: getMensagem
  })

  const handleUpdate = async () => {
    if(isLoading) return;
    startLoading();
    try {
      const req = await api.put('agendamento/bot/'+id, mensagem);
      const res = await req.data;
      setMensagemInfo('Alterado com sucesso');
    } catch(error) {
      setMensagemError(JSON.stringify(error?.response?.data, null, 2))
    } finally {
      stopLoading();
      await reset()
    }
  }

  return {
    getMensagem,
    alterMensagem,
    mensagem: {...mensagem, ...sede},
    isLoading,
    handleUpdate
  }
}
